"use strict";

/*
 * Der News-Stoerer auf der Startseite: die Karte oben rechts, die sich
 * zuklappen laesst.
 *
 * Am 2026-09-08 von jQuery auf natives JavaScript umgeschrieben.
 *
 * NICHT von phantomstaffel uebernommen, obwohl es dort eine fertige Fassung
 * gibt: dort startet der Stoerer **zugeklappt** ("so gewuenscht am
 * 2026-09-01, damit das Kopfbild frei bleibt"), und der sessionStorage merkt
 * sich das Aufklappen. Das ist eine Entscheidung fuer phantomstaffel. Hier
 * startet er offen, und gemerkt wird das Zuklappen - so ist es auf live, und
 * so bleibt es.
 *
 * Das Markup kommt aus Layouts/News/General.html: `.interferer-opened` ohne
 * Klasse, `.interferer-closed` mit `hide d-none`.
 *
 * EIN EIGENHEIT, absichtlich mituebernommen: nach einem Neuladen ist die Karte
 * wieder offen, obwohl sie zugeklappt war. Der Grund steht unten beim
 * Anfangszustand. Das ist auf live genauso; es zu beheben waere eine
 * Verhaltensaenderung, nicht eine Reparatur.
 */

document.addEventListener("DOMContentLoaded", () => {
    const offen = document.querySelectorAll(".interferer-opened");
    const zu = document.querySelectorAll(".interferer-closed");

    if (offen.length === 0 && zu.length === 0) {
        return;
    }

    const setzen = (elemente, klasse, an) => {
        elemente.forEach((el) => el.classList.toggle(klasse, an));
    };

    /* Zuklappen: die Karte weg, den Streifen her. */
    document.querySelectorAll(".interferer-btn-close").forEach((knopf) => {
        knopf.addEventListener("click", () => {
            setzen(offen, "hide", true);
            setzen(zu, "hide", false);
            setzen(zu, "d-none", false);
            try {
                sessionStorage.setItem("interferer", "1");
            } catch (e) {
                /* Im privaten Fenster wirft sessionStorage. Dann eben nicht merken. */
            }
        });
    });

    /*
     * Aufklappen: nicht der Knopf selbst horcht, sondern der Kasten zwei Ebenen
     * darueber - so oeffnet ein Klick irgendwo auf dem zugeklappten Streifen.
     * Vorher stand hier $(".interferer-btn-open").parent().parent(); an der
     * Verschachtelung in Layouts/News/General.html darf sich deshalb nichts
     * aendern.
     */
    document.querySelectorAll(".interferer-btn-open").forEach((knopf) => {
        const kasten = knopf.parentElement && knopf.parentElement.parentElement;
        if (!kasten) {
            return;
        }
        kasten.addEventListener("click", () => {
            setzen(offen, "hide", false);
            setzen(zu, "hide", true);
        });
    });

    /*
     * Der Anfangszustand, Zeichen fuer Zeichen wie in der jQuery-Fassung:
     *
     *   war schon zugeklappt -> `hide` von `.interferer-closed` nehmen
     *   sonst                -> `hide` von `.interferer-opened` nehmen
     *
     * Beides ist fast wirkungslos, denn im Markup traegt `.interferer-opened`
     * kein `hide` und `.interferer-closed` behaelt sein `d-none`. Nach einem
     * Neuladen steht die Karte deshalb wieder offen. Das ist die Eigenheit aus
     * dem Kopf dieser Datei - sie bleibt, weil live sich genauso verhaelt.
     */
    let warZu = false;
    try {
        warZu = sessionStorage.getItem("interferer") !== null;
    } catch (e) {
        warZu = false;
    }

    if (warZu) {
        setzen(zu, "hide", false);
    } else {
        setzen(offen, "hide", false);
    }
});
